module.exports = __webpack_public_path__ + "static/media/renketsu-icon.69203ac5.svg";